import { useEffect } from "react";
import { useSelector } from "react-redux";
import { retrieveVolunteerRegulatoryExchange } from "../../../../redux/slice/volunteer-membership-slice"
import { RootState, useAppDispatch } from "../../../../redux/store";

const VolunteerOpportunitiesListing = () => {

  const dispatch = useAppDispatch()
  const RegulatoryVolunteerData = useSelector((state: RootState) => state.VolunteerRegulatoryExchange.data);

  useEffect(() => {
    dispatch(retrieveVolunteerRegulatoryExchange())
  }, [dispatch])

  return (
    <>
      <h3 className="text-center pb-2">Upcoming Volunteer Opportunties</h3>
      <div className="row thelist">
        {RegulatoryVolunteerData.map(
          (opportunity, index) => {
            const formatDate = new Intl.DateTimeFormat("en-GB", { year: "numeric", month: "long", day: "numeric" });

            const dateStart = formatDate.format(new Date(Date.parse(opportunity.startDateTime)));
            const dateEnd = formatDate.format(new Date(Date.parse(opportunity.endDateTime)));
            let runTime = `Runs from ${dateStart} to ${dateEnd}`;
            let availableSpots = `with ${opportunity.volunteerSpotsAvailable} of ${opportunity.volunteersNeeded} open spots`;
            if (new Date(Date.parse(opportunity.endDateTime)).getFullYear() === 1)
              runTime = "Ongoing";
            if (opportunity.volunteersNeeded === 0)
              availableSpots = "";
            return (
              <div className="col-md-6 opportunity mt-1" key={index}>
                <div style={{ fontSize: "22px" }}>{opportunity.linkToOpportunity ? <a target="_blank" rel="noreferrer" href={opportunity.linkToOpportunity}>{opportunity.opportunityName}</a> : opportunity.opportunityName}</div>
                <div>Experience Required: {opportunity.additionalRequirements}</div>
                <div>{runTime} {availableSpots}</div>
              </div>
            )
          })
        }
      </div >
      <VolunteerStyles />
    </>
  );
}

const VolunteerStyles = () => {
  return (
    <>
      <style>
        {` 
          .thelist .opportunity {  
            border-top: 1px solid #0E8ACB;
            border-left: 4px solid #0E8ACB;
           }
        `}
      </style>
    </>
  )
}

export default VolunteerOpportunitiesListing
